import { graphql, useStaticQuery } from 'gatsby';

export const useFuoData = () => {
  const response = useStaticQuery(graphql`
    query AllOnboardingSteps {
      allStrapiWelcomePage {
        nodes {
          contentfulName
          id
          steps {
            contentfulName
            id
          }
        }
      }
    }
  `);
  return response.allStrapiWelcomePage.nodes;
};

export const onboardingStepCount = () => {
  const onboardingStepsData = useFuoData();
  const stepCount = onboardingStepsData[0].steps.length;
  return stepCount;
};
